import BankidVerificationUI from 'areas/Login/static/script/app/ui/bankId-recovery-ui';

export default function() {
    BankidVerificationUI.attachTo(document);
}
